import { recipesEn } from './recipes-en';
import { batchScalingEn, processRoutingEn } from './process-routing-en';
import { declarationsEn } from './declarations-en';
import { analysisEn } from './analysis-en';

export const plmEn = {
  material: {
    tab: 'Product development',
    roles: {
      TRADING_GOOD: 'Trading good',
      RAW_MATERIAL: 'Raw material',
      SEMI_FINISHED: 'Semi-finished good',
      FINISHED_GOOD: 'Finished good',
      PACKAGING_MATERIAL: 'Packaging material',
      OPERATING_SUPPLY: 'Operating supply',
      BY_PRODUCT: 'By-product',
    },
    sections: {
      roles: 'Usage roles',
      versions: 'Versioned master-data profiles',
      translations: 'Multilingual names',
    },
    help: {
      roles:
        'A product can have several roles at the same time. Changes are saved with a version check.',
      structuredJson:
        'Structured keys and values as a valid JSON object. Enter numbers used in calculations as decimal strings.',
      conversions:
        'JSON list containing fromUnitCode, toUnitCode, factor, offset, roundingScale and usesDensity.',
      dms: 'Only files from this product’s protected DMS record can be selected.',
    },
    messages: {
      saved: 'Master-data version saved.',
      invalid: 'The input is invalid.',
      rolesSaved: 'Usage roles saved.',
      workflowUpdated: 'Workflow updated.',
      submitted: 'Version submitted for review.',
    },
    states: {
      noApproved: 'No master-data version has been approved yet.',
      approvedVersion: 'Approved version: v{{version}}',
      empty: 'No master-data version exists yet.',
      noDocuments: 'The product record does not contain DMS files yet.',
    },
    actions: {
      newVersion: 'New version',
      submit: 'Submit for review',
      approve: 'Approve',
      copy: 'Copy to new version',
      archive: 'Archive',
      confirm: 'Confirm',
    },
    columns: {
      version: 'Version',
      status: 'Status',
      validity: 'Validity',
      names: 'Name',
      suppliers: 'Supplier snapshot',
    },
    statuses: {
      DRAFT: 'Draft',
      IN_REVIEW: 'In review',
      APPROVED: 'Approved',
      SUPERSEDED: 'Superseded',
      ARCHIVED: 'Archived',
    },
    editor: {
      createTitle: 'Create master-data version',
      editTitle: 'Edit master-data version v{{version}}',
      description:
        'Approved versions are immutable. Supplier information is captured server-side as a snapshot when saving.',
    },
    fields: {
      usageRoles: 'Usage roles',
      standardUnit: 'Standard quantity unit',
      shelfLifeDays: 'Shelf life (days)',
      density: 'Density',
      densityUnit: 'Density unit',
      originCountry: 'Country of origin',
      originRegion: 'Region of origin',
      manufacturer: 'Manufacturer',
      manufacturerAddress: 'Manufacturer address',
      validFrom: 'Valid from',
      validTo: 'Valid to',
      internalName: 'Internal name',
      externalName: 'External name',
      declarationName: 'Declaration name',
      storageInstructions: 'Storage instructions',
      technicalProperties: 'Technical properties',
      qualityProperties: 'Quality properties',
      storageConditions: 'Storage conditions',
      foodProfile: 'Optional food profile',
      nutritionProfile: 'Optional nutrition profile',
      allergenInformation: 'Optional allergen information',
      additiveInformation: 'Optional additive information',
      extensionProfiles: 'Industry-specific extension profiles',
      conversions: 'Product-specific conversion factors',
      dmsDocuments: 'DMS documents and supplier specifications',
      changeReason: 'Reason for change',
      reason: 'Reason',
    },
    actionDialog: {
      APPROVE: {
        title: 'Approve master data',
        description:
          'Approval is audit-proof and requires a user other than the creator and submitter.',
      },
      COPY: {
        title: 'Create new version',
        description:
          'The content is copied into a new editable draft and supplier data is captured again.',
      },
      ARCHIVE: {
        title: 'Archive version',
        description: 'The version remains fully traceable but is no longer used actively.',
      },
    },
  },
  recipes: recipesEn,
  processRouting: processRoutingEn,
  batchScaling: batchScalingEn,
  declarations: declarationsEn,
  analysis: analysisEn,
} as const;
